import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar";   // ✅ UNCOMMENT
import PopUp from "./components/popup";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./routes/ScrollToTop";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />     {/* ONLY HERE */}
      <PopUp />
      <AppRoutes />
      <Footer />
    </Router>
  );
}



export default App;
